import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default () => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `0 ${scale.xs}`,
    paddingLeft: 0,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },
  faqContainer: {
    paddingLeft: 0,
  },
  panel: {
    background: colors.light_grey,
    padding: scale.m,
    marginBottom: scale.m,
  },
  groupContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  summaryHeading: {
    marginTop: 0,
    marginBottom: scale.s,
  },
  summaryIcon: {
    marginRight: '5px',
  },
  groupHeading: {
    marginTop: 0,
    marginBottom: scale.xs,
    fontSize: heights.s,
  },
  summaryGroup: {},
  links: {
    listStyle: 'none',
    padding: 0,
    paddingRight: scale.s,
  },
  linkItem: {
    paddingBottom: 5,
  },
  link_url: {
    color: colors.black,
    textDecoration: 'underline',
  },
});
